import config from './config';
import store from '../helpers/store';
import { cloneDeep, get } from 'lodash';

function getConfig(){
	const userData = store.get('user');
	const fullReports = get(userData, 'statement_reports', false);
	let configData = cloneDeep(config);
	if(fullReports)
		configData.fullCSVThreshold = configData.adminCSVThreshold;
	return configData;
}

export default getConfig;	